import { render, staticRenderFns } from "./bulk_update.vue?vue&type=template&id=369ef3ad&lang=pug&"
import script from "./bulk_update.vue?vue&type=script&lang=coffee&"
export * from "./bulk_update.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./bulk_update.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports